import { useMemo } from 'react';
import { pick } from 'ramda';

import { useRecentlyGamesSelector } from 'js/app/store/hooks/useRecentlyGames';
import { useAppSelector, usePageSelector, useUserSelector } from 'js/store/hooks';

export const useIsPageFullLoaded = () => {
    const { isLoggedIn, allPlayerTags } = useUserSelector(pick(['isLoggedIn', 'allPlayerTags']));
    const { recentlyPlayedLoaded } = useRecentlyGamesSelector();
    const { webContentLoadings, isPageRendered } = usePageSelector(pick(['webContentLoadings', 'isPageRendered']));
    const {
        isGamesLoaded, isLoadingMenuItems, isFavoritesFetching
    } = useAppSelector(pick(['isGamesLoaded', 'isLoadingMenuItems', 'isFavoritesFetching']));

    return useMemo(() => {
        return isGamesLoaded
            && !isLoadingMenuItems
            && isPageRendered
            && !Object.keys(webContentLoadings).length
            && (isLoggedIn
                ? allPlayerTags && recentlyPlayedLoaded && !isFavoritesFetching
                : true);
    }, [
        allPlayerTags,
        isFavoritesFetching,
        isGamesLoaded,
        isLoadingMenuItems,
        isLoggedIn,
        isPageRendered,
        recentlyPlayedLoaded,
        webContentLoadings
    ]);
};
